
var lib_core = require("lib-core");
var cio_config = require("cio-config");

var UserSettingsModel = function (root, config) {
    var self = this;
    lib_core.Model.call(this);

    this.distanceUnit = this.value("distanceUnit", true);
    this.distanceUnit(cio_config.UnitConversions.Millimeters.getInspectorName());
    this.rotationUnit = this.value("rotationUnit", true);
    this.rotationUnit(cio_config.UnitConversions.Degrees.getInspectorName());

    this.locale = this.value("localeLanguage", true);
    this.locale("en");

    this.localeStrings = cio_config.Localization.getLocaleStrings(self.locale());
    this.locale.onChange(this, function() {
        self.localeStrings = cio_config.Localization.getLocaleStrings(self.locale());
    });

};
lib_core.inherit(UserSettingsModel, lib_core.Model);
UserSettingsModel.$class = "UserSettingsModel";

module.exports = UserSettingsModel;

UserSettingsModel.prototype.getLocaleString = function(key, defaultValue) {
    if (!this.localeStrings) {
        console.warn(this.locale() + ' locale strings are missing.');
        return defaultValue;
    } else {
        if (key in this.localeStrings) {
            return this.localeStrings[key];
        } else {
            return defaultValue;
        }
    }   
};